import { matchPath } from 'react-router-dom';
import { VenueId } from '../../venues/venues.types';

export interface VenueAccessException {
    venueId: VenueId;
    path: string;
    roles?: number[];
}

export const VENUE_ACCESS_EXCEPTIONS: VenueAccessException[] = [];

export const isVenueAccessException = (
    venueId: VenueId,
    pathname: string,
    roleId?: number
): boolean =>
    VENUE_ACCESS_EXCEPTIONS.some(
        (ex) =>
            ex.venueId === venueId &&
            !!matchPath({ path: ex.path, end: true }, pathname) &&
            (!ex.roles || (roleId != null && ex.roles.includes(roleId)))
    );
